import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../../axios";

const NotUploadTimetable = ({props}) => {
  return (
    <>
      <div className="full_details2">
        <img
          src="/images/cross-circle3.svg"
          className="create_channel_close_btn1"
          alt="cross circle"
          onClick={props.helper1}
        />
        <div className="d-flex justify-content-center">
        <img
                        className="error_file_icon"
                        src="/DCM-img/error_icon.svg"
                        alt=""
                      ></img>
                    </div>
        <div className="divText2">You are not the classteacher or coordinator of  </div>
        <div className="divText1">uploaded timetable.</div>
      </div>
    </>
  );
};

export default NotUploadTimetable;
